// Recordings and dates (AdminRecordings.dc.html): the Recordings tab, and Cohorts and dates with each
// held session's register at /admin/recordings/dates/<session id>. The pieces are in src/admin/content/.
// A host is sent to Cohorts and dates by the shell, and sees only their product's cohorts and registers.
import { useAdmin, Loading, Problem, useLoad } from '../ui/index.js'
import { ContentHead } from '../content/Head.jsx'
import { RecordingsTab } from '../content/RecordingsTab.jsx'
import { DatesTab } from '../content/DatesTab.jsx'
import { Register } from '../content/Register.jsx'
import { loadContent } from '../content/data.js'
import '../../styles/admin-content.css'

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export default function Recordings({ role, route, api, me }) {
  const { personId } = useAdmin()
  const tab = route.params.tab === 'dates' ? 'dates' : 'recordings'
  const registerId = tab === 'dates' && UUID.test(route.params.rest?.[0] || '') ? route.params.rest[0].toLowerCase() : null
  const content = useLoad(() => loadContent(api, role), [api, role])

  let body
  if (content.status === 'loading' && !content.data) body = <Loading />
  else if (!content.data) body = <Problem error={content.error} onRetry={content.reload} />
  else {
    const shared = { data: content.data, reload: content.reload, api, role, personId }
    if (registerId) body = <Register sessionId={registerId} data={content.data} api={api} meName={me?.person?.full_name} role={role} />
    else if (tab === 'dates') body = <DatesTab {...shared} />
    else body = <RecordingsTab {...shared} />
  }
  return (
    <>
      <ContentHead role={role} current={tab} />
      {body}
    </>
  )
}
